import { CTA_CHECKOUT_TEXT, CTA_COMPLETE_FREE_TEXT } from '../../constants';
import { CheckoutState } from '../../state';
import { getIsFreeEvent } from './pureSelectors';

export const getTicketSelectDefaultCtaText = (state: CheckoutState) =>
    getIsFreeEvent(state) ? CTA_COMPLETE_FREE_TEXT : CTA_CHECKOUT_TEXT;
